<template>
  <div
    class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen"
  >
    <!-- Header -->
    <div class="mb-6 md:mb-8">
      <h1
        class="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 dark:text-slate-100 mb-2"
      >
        Panel de Limpieza
      </h1>
      <p class="text-sm md:text-base text-slate-600 dark:text-slate-400">
        Gestión de habitaciones - {{ fechaActual }}
      </p>
    </div>

    <!-- Filtro de Fecha -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-6 md:mb-8"
    >
      <h2
        class="text-base font-semibold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2"
      >
        <i class="bx bx-filter-alt text-custom-primary"></i> Filtro de Fecha
      </h2>
      <div class="flex flex-wrap gap-4 items-end">
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Fecha inicio</label
          >
          <input
            type="date"
            v-model="filtro.fechaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hora inicio</label
          >
          <input
            type="time"
            v-model="filtro.horaInicio"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Fecha fin</label
          >
          <input
            type="date"
            v-model="filtro.fechaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <div>
          <label class="text-xs text-slate-500 dark:text-slate-400 mb-1 block"
            >Hora fin</label
          >
          <input
            type="time"
            v-model="filtro.horaFin"
            class="border border-slate-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-custom-primary"
          />
        </div>
        <button
          @click="cargarTodo"
          class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0"
        >
          <i class="bx bx-refresh mr-1"></i>Actualizar
        </button>
      </div>
    </div>

    <!-- Acciones Rápidas -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6 md:mb-8"
    >
      <h2
        class="text-lg md:text-xl font-semibold text-slate-800 dark:text-slate-100 mb-4 md:mb-6"
      >
        Acciones Rápidas
      </h2>
      <div class="flex justify-center">
        <button
          @click="$router.push('/limpieza-Habitaciones')"
          class="flex flex-col items-center justify-center p-6 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all shadow-md hover:shadow-lg group border-0"
        >
          <i
            class="bx bx-spray-can text-4xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"
          ></i>
          <span
            class="text-base text-center text-slate-700 dark:text-slate-300 font-medium"
            >Gestionar Limpieza de Habitaciones</span
          >
        </button>
      </div>
    </div>

    <!-- Stats Grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8"
    >
      <!-- Pendientes -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div class="p-2 md:p-3 bg-red-100 dark:bg-red-900/30 rounded-lg">
            <i
              class="bx bx-time text-2xl md:text-3xl text-red-600 dark:text-red-400"
            ></i>
          </div>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.pendientes }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Habitaciones Pendientes
        </p>
      </div>

      <!-- En Proceso -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div
            class="p-2 md:p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg"
          >
            <i
              class="bx bx-loader-alt text-2xl md:text-3xl text-yellow-600 dark:text-yellow-400"
            ></i>
          </div>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.enProceso }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          En Proceso
        </p>
      </div>

      <!-- Completadas Hoy -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-center justify-between mb-3">
          <div class="p-2 md:p-3 bg-green-100 dark:bg-green-900/30 rounded-lg">
            <i
              class="bx bx-check text-2xl md:text-3xl text-green-600 dark:text-green-400"
            ></i>
          </div>
        </div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
        >
          {{ stats.completadas }}
        </h3>
        <p class="text-xs md:text-sm text-slate-600 dark:text-slate-400">
          Completadas Hoy
        </p>
      </div>
    </div>

    <!-- Lista de Habitaciones -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6 md:mb-8"
    >
      <h2
        class="text-lg md:text-xl font-semibold text-slate-800 dark:text-slate-100 mb-4 md:mb-6"
      >
        Habitaciones Asignadas
      </h2>
      <div
        v-if="habitaciones.length === 0"
        class="text-center text-slate-500 dark:text-slate-400 py-8"
      >
        No hay habitaciones pendientes de limpieza
      </div>
      <div v-else class="space-y-3">
        <div
          v-for="(hab, index) in habitaciones"
          :key="index"
          class="flex items-center justify-between p-3 md:p-4 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
        >
          <div class="flex items-center gap-3">
            <div
              :class="[
                'w-12 h-12 rounded-lg flex items-center justify-center',
                hab.prioridad === 'Alta'
                  ? 'bg-red-100 dark:bg-red-900/30'
                  : hab.prioridad === 'Media'
                  ? 'bg-yellow-100 dark:bg-yellow-900/30'
                  : 'bg-blue-100 dark:bg-blue-900/30',
              ]"
            >
              <span
                class="text-lg font-bold"
                :class="[
                  hab.prioridad === 'Alta'
                    ? 'text-red-600 dark:text-red-400'
                    : hab.prioridad === 'Media'
                    ? 'text-yellow-600 dark:text-yellow-400'
                    : 'text-blue-600 dark:text-blue-400',
                ]"
                >{{ hab.numero }}</span
              >
            </div>
            <div>
              <p class="text-sm font-medium text-slate-800 dark:text-slate-100">
                {{ hab.tipo }}
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                {{ hab.estado }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span
              :class="[
                'text-xs font-medium px-2 py-1 rounded-full',
                hab.prioridad === 'Alta'
                  ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                  : hab.prioridad === 'Media'
                  ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                  : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
              ]"
            >
              {{ hab.prioridad }}
            </span>
            <button
              @click="$router.push('/limpieza-Habitaciones')"
              class="text-custom-primary hover:opacity-80 text-sm font-medium px-3 py-1.5 rounded-md transition-all border-0 bg-transparent"
            >
              Iniciar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "../../config/config.js";

export default {
  name: "DashboardLimpieza",
  data() {
    const hoy = new Date();
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    return {
      loading: true,
      filtro: {
        fechaInicio: hoy.toISOString().slice(0, 10),
        horaInicio: '08:00',
        fechaFin: manana.toISOString().slice(0, 10),
        horaFin: '08:00',
      },
      stats: {
        pendientes: 0,
        enProceso: 0,
        completadas: 0,
      },
      habitaciones: [],
    };
  },
  computed: {
    fechaActual() {
      const opciones = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date().toLocaleDateString("es-ES", opciones);
    },
    datetimeInicio() {
      return `${this.filtro.fechaInicio} ${this.filtro.horaInicio}:00`;
    },
    datetimeFin() {
      return `${this.filtro.fechaFin} ${this.filtro.horaFin}:00`;
    },
  },
  methods: {
    async cargarStats() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_URL}/dashboard/limpieza`, {
          params: {
            fecha_inicio: this.datetimeInicio,
            fecha_fin: this.datetimeFin,
          },
        });

        this.stats.pendientes = response.data.pendientes || 0;
        this.stats.enProceso = response.data.enProceso || 0;
        this.stats.completadas = response.data.completadas || 0;

        this.loading = false;
      } catch (error) {
        console.error("Error cargando estadísticas:", error);
        this.loading = false;
      }
    },
    async cargarHabitaciones() {
      try {
        const response = await axios.get(
          `${API_URL}/dashboard/habitaciones-pendientes-limpieza`,
        );
        this.habitaciones = response.data.map((item) => ({
          numero: item.Numero,
          tipo: item.TipoNombre,
          estado: "Espera de limpieza",
          prioridad: item.Prioridad,
        }));
      } catch (error) {
        console.error("Error cargando habitaciones:", error);
      }
    },
    cargarTodo() {
      this.cargarStats();
      this.cargarHabitaciones();
    },
  },
  mounted() {
    this.cargarTodo();
  },
};
</script>
